import { Button, Dropdown, Space, Drawer } from 'antd'
import { GlobalOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import './index.scss'
import { Link, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

const items: MenuProps['items'] = [
    {
        key: '1',
        label: 'English',
    },
]

export const Header = () => {
    const navigate = useNavigate()
    const [screenSize, setScreenSize] = useState(window.innerWidth)
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    const closeMenu = () => {
        setIsMenuOpen(false)
    }

    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    return (
        <header className="header">
            <div className="logo">
                <Link to="/" className="logo-link">
                    {
                        screenSize < 768 ? (
                            <img
                                src="/logo-mobile.svg"
                                width={66}
                                height={48}
                                alt="moodra logo"
                            />
                        ) : (
                            <img
                                src="/logo.svg"
                                width={224}
                                height={48}
                                alt="moodra logo"
                            />
                        )
                    }
                </Link>
            </div>

            {/* <button
                className="mobile-menu-button"
                onClick={() => setIsMenuOpen(true)}
            >
                <MenuOutlined style={{ fontSize: '1.5rem', color: '#737373' }} />
            </button> */}

            <Button type="text" className="mobile-menu-button" onClick={() => setIsMenuOpen(true)} size='large'>
                <img src="/images/icon-hamburger.svg" alt="menu" />
            </Button>

            {/* Desktop nav items */}
            <div className="nav-items desktop">
                <Space size={24}>
                    <Link to="/contact-us" className="contact-link">
                        Contact us
                    </Link>
                    <Button type="primary" className="waitlist-button" onClick={() => navigate('/survey/beginning')}>
                        Start Survey
                    </Button>
                    <Dropdown menu={{ items }} placement="bottomRight" arrow>
                        <Button type="text" className='header-lang-btn'>
                            <img src="/images/icon-lang.svg" alt="lang" />
                            <img src="/images/icon-arrow-down.svg" alt="arrow-down" />
                        </Button>
                    </Dropdown>
                </Space>
            </div>

            {/* Mobile drawer */}
            <Drawer
                placement="right"
                onClose={closeMenu}
                open={isMenuOpen}
                width="100%"
                className="mobile-menu-drawer"
                styles={{
                    body: {
                        padding: 0,
                    }
                }}
            >
                <div className="mobile-menu-content">
                    <Space direction="vertical" size={24} className="mobile-nav-items">
                        <Link to="/contact-us" className="contact-link" onClick={closeMenu}>
                            Contact us
                        </Link>
                        <Button
                            type="primary"
                            className="waitlist-button"
                            onClick={() => {
                                navigate('/survey/beginning')
                                closeMenu()
                            }}
                        >
                            Start Survey
                        </Button>
                        <Dropdown menu={{ items }} placement="bottomRight" arrow>
                            <Button type="text" icon={<GlobalOutlined style={{ fontSize: '1.5rem', color: '#737373' }} />} />
                        </Dropdown>
                    </Space>
                </div>
            </Drawer>
        </header>
    )
}
